// Persistence boundary. The engine only talks to this interface; the browser
// glue provides an IndexedDB implementation (src/ui/idbstore.ts) and tests /
// non-browser runs use MemoryStore. Values are ArrayBuffers or JSON-able
// objects — the engine serializes SSTables and WAL records to bytes itself.

export interface KVStore {
  get(table: string, key: string): Promise<unknown | undefined>;
  put(table: string, key: string, value: unknown): Promise<void>;
  delete(table: string, key: string): Promise<void>;
  /** All entries of a table, ordered by key (string order). */
  entries(table: string): Promise<[string, unknown][]>;
  clear(table: string): Promise<void>;
}

export class MemoryStore implements KVStore {
  private tables = new Map<string, Map<string, unknown>>();

  private t(name: string): Map<string, unknown> {
    let m = this.tables.get(name);
    if (!m) {
      m = new Map();
      this.tables.set(name, m);
    }
    return m;
  }

  async get(table: string, key: string) {
    return this.t(table).get(key);
  }
  async put(table: string, key: string, value: unknown) {
    this.t(table).set(key, value);
  }
  async delete(table: string, key: string) {
    this.t(table).delete(key);
  }
  async entries(table: string): Promise<[string, unknown][]> {
    return [...this.t(table).entries()].sort((a, b) =>
      a[0] < b[0] ? -1 : a[0] > b[0] ? 1 : 0,
    );
  }
  async clear(table: string) {
    this.t(table).clear();
  }
}
